//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
import { uid } from "quasar";
import draggable from "vuedraggable";
import { required } from "vuelidate/lib/validators";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import setRules from "@/components/Diagrams/config/set-rules.vue";
import setApprovalTime from "@/components/Diagrams/config/set-approval-time.vue";
import setContinueIfRejected from "@/components/Diagrams/config/set-continue-if-rejected.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    components: {
        draggable,
        AQModal,
        AQInput,
        setRules,
        setApprovalTime,
        setContinueIfRejected,
        AQButton,
        AQDialog,
        AQCard
    },
    props: {
        uuid: {
            type: String
        },
        elementIndex: {
            type: Number
        },
        readonly: {
            type: Boolean
        },
        value: {
            type: null
        }
    },
    data() {
        return {
            modalOpened: false,
            saveEnabled: true,
            hasClose: true,
            selectedLevel: null,
            selectedIndex: 0,
            drag: false,
            nameError: false,
            isFirstLevel: true,
            modalHeaderActions: [
                {
                    value: "deleteLevel",
                    label: this.$t("diagrams.components.setLevels.delete")
                }
            ],
            localLevels: [],
            currentDataExpiration: null,
            resetApproval: false,
            levelsWarningDlg: false
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        ...mapGetters("rules", ["getCurrentRule", "showRuleTesting"]),
        levels: {
            get() {
                return this.value || [];
            },
            set(v) {
                this.$emit(
                    "input",
                    v.map((value, index) => ({ ...value, index }))
                );
            }
        },
        setHeaderActions() {
            let options = [];
            if (!this.readonly && this.showHeaderActions) {
                options = this.modalHeaderActions;
            }
            return options;
        },
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: this.readonly || this.$v.$invalid || !this.saveEnabled || this.disableOnEmptyRules
            };
        },
        hasTest() {
            return this.readonly ? null : { label: this.$t("generic.test"), disabled: this.$v.$invalid || this.disableOnEmptyRules };
        },
        disableOnEmptyRules() {
            return this.selectedLevel && !this.selectedLevel.rules.length;
        },
        disableOnEmptyLevel() {
            let disableLevel = false;
            if (
                this.selectedPluginConfigData.levels
                && this.selectedPluginConfigData.levels.length
            ) {
                disableLevel = !!this.selectedPluginConfigData.levels.find(
                    element => !element.rules.length
                );
            }
            return disableLevel;
        },
        currentOutcomesValue() {
            return {
                ifExpires: this.selectedLevel.settings.ifExpires,
                continueIfRejected: this.selectedLevel.settings
                    .continueIfRejected
            };
        },
        showHeaderActions() {
            return this.selectedLevel.index !== this.localLevels.length;
        }
    },
    watch: {
        showRuleTesting: {
            handler(value) {
                if (value) {
                    this.hide();
                }
            },
            immediate: true
        },
        selectedLevel: {
            handler(newV, oldV) {
                this.saveEnabled = !!oldV;
            },
            deep: true
        },
        value: {
            handler() {
                this.refreshLocalLevels();
            },
            immediate: true
        }
    },
    validations: {
        selectedLevel: {
            name: {
                required
            }
        }
    },
    deactivated() {
        this.$store.commit("rules/setCurrentLevel", {});
        this.$store.commit("rules/setCurrentRule", {});
        this.selectedLevel = null;
    },
    created() {
        this.$root.$on("openSelectedLevel", currentLevel => {
            this.selectedLevel = currentLevel;
            this.selectedIndex = currentLevel.index + 1;
            this.modalOpened = true;
        });
    },
    methods: {
        ...mapMutations("rules", ["setShowRuleTesting", "setTestAllRules"]),
        checkNameState() {
            if (this.selectedLevel) {
                this.nameError = !this.selectedLevel.name;
            }
        },
        selectLevel(index) {
            this.selectedLevel = this.localLevels[index];
            this.selectedIndex = index + 1;
            this.modalOpened = true;
            this.currentDataExpiration = {
                approvalTime: this.selectedLevel.settings.approvalTime,
                ifExpires: this.selectedLevel.settings.ifExpires
            };
            this.$store.commit("rules/setCurrentLevel", this.selectedLevel);
        },
        selectedBehaviour(selectedType) {
            this.selectedLevel.settings.ifExpires = selectedType;
        },
        workScheduleInfo(data) {
            if (this.selectedLevel.settings.useWorkingSchedule !== data) {
                this.saveEnabled = true;
            }
            this.selectedLevel.settings.useWorkingSchedule = data;
        },
        okLevelsWarningDlg() {
            if (this.resetApproval) {
                this.resetCurrentExpiration();
                this.resetApproval = false;
            } else {
                this.$store.commit("rules/setCurrentLevel", {});
                this.$store.commit("rules/setCurrentRule", {});
                this.selectedLevel = null;
                this.hide();
            }
        },
        action(action) {
            if (action === "primary") {
                this.$refs.appovalTimeComp.$v.timeToExpiration.$touch();
                if (this.$v.$invalid) {
                    this.nameError = true;
                    return false;
                }
                if (this.$refs.appovalTimeComp.$v.timeToExpiration.$invalid) {
                    return false;
                }
                const currentLevels = [...this.localLevels];
                let isUpdate = currentLevels.find(
                    el => el.uuid === this.selectedLevel.uuid
                );

                if (isUpdate) {
                    isUpdate = { ...this.selectedLevel };
                } else {
                    currentLevels.push(this.selectedLevel);
                }

                this.$emit("input", currentLevels);
                this.resetCurrentLevel();
                this.hide();
            } else if (action === this.$t("diagrams.components.setLevels.delete")) {
                this.$emit(
                    "input",
                    this.localLevels
                        .filter(lvl => lvl.uuid !== this.selectedLevel.uuid)
                        .map((value, index) => ({ ...value, index }))
                );
                this.resetCurrentLevel();
                this.hide();
            } else if (action === "secondary") {
                const currentLevels = this.levels;
                const isUpdate = currentLevels.find(
                    el => el.uuid === this.selectedLevel.uuid
                );
                if (isUpdate) {
                    for (let i = 0; i < currentLevels.length; i++) {
                        if (
                            this.selectedLevel
                            && currentLevels[i].uuid === this.selectedLevel.uuid
                        ) {
                            if (
                                JSON.stringify(currentLevels[i])
                                !== JSON.stringify(this.selectedLevel)
                            ) {
                                this.$store.commit("main/setInterfaceDirty", true);
                            }
                        }
                    }
                } else {
                    this.$store.commit("main/setInterfaceDirty", true);
                }

                this.$store.commit("rules/setShowRuleTesting", true);
            } else if (action === "close") {
                const currentLevels = this.levels;
                const isUpdate = currentLevels.find(
                    el => el.uuid === this.selectedLevel.uuid
                );
                if (isUpdate) {
                    for (let i = 0; i < currentLevels.length; i++) {
                        if (
                            this.selectedLevel
                            && currentLevels[i].uuid === this.selectedLevel.uuid
                        ) {
                            if (
                                JSON.stringify(currentLevels[i])
                                !== JSON.stringify(this.selectedLevel)
                            ) {
                                this.resetApproval = true;
                                this.levelsWarningDlg = true;
                            } else {
                                this.resetCurrentLevel();
                                this.hide();
                            }
                        }
                    }
                } else {
                    const tempLevel = {
                        uuid: this.selectedLevel.uuid,
                        name: "",
                        description: "",
                        settings: {
                            approvalTime: {
                                days: 2,
                                hours: 12,
                                minutes: 0
                            },
                            ifExpires: "AR",
                            continueIfRejected: false
                        },
                        rules: [],
                        index: this.localLevels.length
                    };
                    if (
                        JSON.stringify(tempLevel)
                        !== JSON.stringify(this.selectedLevel)
                    ) {
                        this.levelsWarningDlg = true;
                    } else {
                        this.selectedLevel = null;
                        this.hide();
                    }
                }
            }
            return false;
        },
        resetCurrentLevel() {
            this.$store.commit("rules/setCurrentLevel", {});
            this.selectedLevel = null;
        },
        hide() {
            this.modalOpened = false;
            this.nameError = false;
        },
        addNewLevel() {
            this.selectedLevel = {
                uuid: uid(),
                name: "",
                description: "",
                settings: {
                    approvalTime: {
                        days: 2,
                        hours: 12,
                        minutes: null
                    },
                    ifExpires: "AR",
                    continueIfRejected: false
                },
                rules: [],
                index: this.localLevels.length
            };

            this.selectedIndex = this.localLevels.length + 1;
            this.modalOpened = true;
        },
        refreshLocalLevels() {
            this.localLevels = JSON.parse(JSON.stringify(this.value || []));
        },
        openRuleTesting() {
            this.$store.commit("rules/setShowRuleTesting", true);
            this.$store.commit("rules/setTestAllRules", true);
        },
        afterShowModal() {
            if (Object.entries(this.getCurrentRule).length) {
                this.$store.commit("rules/setBackToDiagram", true);
            }
        },
        resetCurrentExpiration() {
            this.selectedLevel.settings.approvalTime = this.currentDataExpiration.approvalTime;
            this.selectedLevel.settings.ifExpires = this.currentDataExpiration.ifExpires;
            this.$nextTick(() => {
                this.currentDataExpiration = null;
                this.$store.commit("rules/setCurrentLevel", {});
                this.$store.commit("rules/setCurrentRule", {});
                this.selectedLevel = null;
                this.hide();
            });
        }
    }
};
